(function () {
  // Pop Convert (shopify://apps/pop-convert) renders its own bottom bar in a
  // shadow root with a max z-index, always on top of everything else. Its
  // presence (and height) is temporary/content-driven — this just keeps
  // --fnd-promo-bar-height in sync with whatever is currently showing, so
  // other fixed bottom UI (cookie banner, chat launcher, etc.) can react via
  // CSS without needing updates when the promo bar's content changes or
  // disappears entirely.
  function findPromoBar() {
    var host = document.getElementById('pop-convert-app');
    return host && host.shadowRoot ? host.shadowRoot.querySelector('.pc-bar') : null;
  }

  function sync() {
    var bar = findPromoBar();
    var height = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--fnd-promo-bar-height', height + 'px');
  }

  sync();
  window.addEventListener('resize', sync);

  var shadowObserverAttached = false;
  function tryAttachShadowObserver() {
    var host = document.getElementById('pop-convert-app');
    if (host && host.shadowRoot && window.MutationObserver && !shadowObserverAttached) {
      shadowObserverAttached = true;
      new MutationObserver(sync).observe(host.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
      });
      sync();
    }
    return shadowObserverAttached;
  }

  // The app's host element (and its shadow content) can be injected after
  // this script runs, so watch the document until it shows up.
  if (!tryAttachShadowObserver() && window.MutationObserver) {
    var bodyObserver = new MutationObserver(function () {
      if (tryAttachShadowObserver()) bodyObserver.disconnect();
    });
    bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Belt-and-braces: poll briefly too, in case the bar's own size changes
  // without a detectable mutation (e.g. an internal animation/transition).
  var attempts = 0;
  var poll = setInterval(function () {
    sync();
    if (++attempts > 20) clearInterval(poll);
  }, 500);
})();
